const GET_OUTAGE_BANNER_DETAILS_BEGIN = 'header/banners/OutageBanner/GET_OUTAGE_BANNER_DETAILS/BEGIN';
const GET_OUTAGE_BANNER_DETAILS_SUCCESS = 'header/banners/OutageBanner/GET_OUTAGE_BANNER_DETAILS/SUCCESS';
const GET_OUTAGE_BANNER_DETAILS_FAILURE = 'header/banners/OutageBanner/GET_OUTAGE_BANNER_DETAILS/FAILURE';

export {
  GET_OUTAGE_BANNER_DETAILS_BEGIN,
  GET_OUTAGE_BANNER_DETAILS_SUCCESS,
  GET_OUTAGE_BANNER_DETAILS_FAILURE
};
